import { enumDependantEntityType, enumDependencyModelType, enumDependencyState } from '@data-layer/enums/dependencies';
import { DependencyModel } from '@data-layer/models/dependencies';
import { IsfV1Model } from '@data-layer/models/isf-v1';
import { EntityModel } from '@data-layer/models/entities';
import {
  CBP_MESSAGE,
  CONSIGNEE_NOT_FOUND,
  ENTITY_IDENTIFIER_NOT_ON_FILE,
  IMPORTER_NOT_FOUND,
  MANUFACTURER_NOT_FOUND,
} from '@constants/cbp-messages';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { ManagementEntrySummaryModel, ManagementIsfModel } from '@data-layer/models/management';
import { IsfModel } from '@data-layer/models/isf';

export class DependencyHelper {
  private static entityTypeRouterMap = {
    [enumDependantEntityType.ENTRY_SUMMARY]: 'es',
  };
  private static modelTypeRouterMap = {
    [enumDependencyModelType.IMPORTER]: 'importer',
    [enumDependencyModelType.CONSIGNEE]: 'consignee',
    [enumDependencyModelType.MANUFACTURER]: 'manufacturer',
  };
  private static readonly cbpMessageToDepModelType: Map<string, enumDependencyModelType> = new Map([
    [CBP_MESSAGE(IMPORTER_NOT_FOUND), enumDependencyModelType.IMPORTER],
    [CBP_MESSAGE(CONSIGNEE_NOT_FOUND), enumDependencyModelType.CONSIGNEE],
    [CBP_MESSAGE(MANUFACTURER_NOT_FOUND), enumDependencyModelType.MANUFACTURER],
    ['ENTRY_ERROR_MESSAGES.MANUFACTURER_NOT_REGISTERED', enumDependencyModelType.MANUFACTURER],
  ]);
  private static readonly isfEntityToDepModelType: Map<enumEntityModelCode, enumDependencyModelType> = new Map([
    [enumEntityModelCode.IMPORTER, enumDependencyModelType.IMPORTER],
    [enumEntityModelCode.CONSIGNEE, enumDependencyModelType.CONSIGNEE],
  ]);

  public static registerLink(
    modelType: enumDependencyModelType,
    entityType: enumDependantEntityType,
    entity: IsfV1Model | IsfModel | ManagementIsfModel | EntrySummaryModel | ManagementEntrySummaryModel,
    modelId: EntityModel['id'],
  ) {
    const entityRoute = this.entityTypeRouterMap[entityType];
    const modelRoute = this.modelTypeRouterMap[modelType];
    if (!entityRoute || !modelRoute) {
      return [];
    }
    return ['/register', entityRoute, entity.id + '-' + entity.referenceNumber, modelRoute, modelId];
  }

  public static registerMessage(dep: DependencyModel) {
    let result = '';

    if (dep) {
      result = 'REGISTER.STATE_MESSAGE.' + enumDependencyState[dep.state];
    }

    return result;
  }

  public static registerButtonText(messageKey: string, dep: DependencyModel) {
    return !dep ? 'BUTTON.PLEASE_REGISTER' : dep.state === enumDependencyState.REJECTED ? 'BUTTON.TRY_AGAIN' : '';
  }

  public static showRegisterButton(messageKey: string, dep: DependencyModel, entityCode: enumEntityModelCode = null) {
    if (
      ![
        CBP_MESSAGE(IMPORTER_NOT_FOUND),
        CBP_MESSAGE(CONSIGNEE_NOT_FOUND),
        CBP_MESSAGE(MANUFACTURER_NOT_FOUND),
        CBP_MESSAGE(ENTITY_IDENTIFIER_NOT_ON_FILE),
        'ENTRY_ERROR_MESSAGES.MANUFACTURER_NOT_REGISTERED',
      ].includes(messageKey) ||
      (messageKey === CBP_MESSAGE(ENTITY_IDENTIFIER_NOT_ON_FILE) &&
        ![enumEntityModelCode.IMPORTER, enumEntityModelCode.CONSIGNEE].includes(entityCode))
    ) {
      return false;
    }
    return !dep || dep.state === enumDependencyState.REJECTED;
  }

  public static getEntityTypeText(type: enumDependencyModelType) {
    return 'REGISTER.ENTITY_TYPE.' + enumDependencyModelType[type];
  }

  public static getEntityTypeByKey(key: string): enumDependencyModelType {
    return this.cbpMessageToDepModelType.get(key);
  }

  public static getEntityTypeByCode(code: enumEntityModelCode): enumDependencyModelType {
    return this.isfEntityToDepModelType.get(code);
  }
}
